import React from 'react';
import ReactMapGl, { NavigationControl, Marker, Popup } from 'react-map-gl';
import ReactLoading from 'react-loading';
import axios from 'axios';
import { HambergerMenu, Cloud, CloseSquare, Location } from 'iconsax-react';
import Graphs from './Graphs';
import Scrollbars from 'react-custom-scrollbars-2';

export interface NodeData {
  name: string,
  location: {
    name: string,
    coordinates: [number, number]
  },
  _id: string,
  history: [{
    temp: string,
    humidity: string,
    bar_pressure: string,
    vapor_pressure: string,
    date: Date
  }],
  isactive: boolean
}

function App() {
  const [showMain, setShowMain] = React.useState(true)
  const [viewPort, setViewPort] = React.useState({
    latitude: 9.072264,
    longitude: 7.491302,
    zoom: 6
  })
  const [activeNode, setActiveNode] = React.useState<NodeData | null>(null);
  const [nodeData, setNodeDate] = React.useState<NodeData[]>([]);
  const [showGraph, setShowGraph] = React.useState(false);
  const [graphState, setGraphState] = React.useState<any[]>([])

  // function onActiveNodeChange(node: NodeData) {
  //   setViewPort({
  //     latitude: node.location.coordinates[0],
  //     longitude: node.location.coordinates[1],
  //     zoom: 18
  //   })
  // }

  // React.useEffect(() => { activeNode && onActiveNodeChange(activeNode) }, [activeNode])

  async function getNodesDate() {
    try {
      const res = await axios.get(process.env.REACT_APP_API_URL + '/api/nodes')
      if (res.status === 200) {
        setNodeDate(res.data.data);
      }
    } catch (e: any) {

    }
  }


  React.useEffect(
    () => {
      if (!activeNode)
        return;
      setGraphState(activeNode.history)
      var websocket = new WebSocket(`${window.location.protocol === 'http' ? 'ws://' : 'wss://'}/${window.location.host}/ws/${activeNode._id}`);
      websocket.onopen = e => {
        console.log("the websocket has connected successfull");
      }
      websocket.onmessage = e => {
        // console.log('message  ')
        try {
          const message = JSON.parse(e.data);
          if (message.data) {
            setGraphState(message.data)
          }
        } catch (e: any) {
          console.log(e.message)
        }
      }

      return function () { websocket?.close && websocket?.close() }

    }, [activeNode])





  React.useEffect(() => {
    getNodesDate();
  }, [])

  return (
    <div className='w-full h-screen'>
      <ReactMapGl
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        {...viewPort}
        style={{ width: '100vw', height: '100vh' }}
        mapStyle="mapbox://styles/kayodele/cleoj9o3b006o01p5139x6iyo"
        onMove={evt => setViewPort(evt.viewState)}
      >
        {/* Graph Components */}
        <NavigationControl position='top-right' />
        {
          nodeData.map(node => <Marker
            longitude={node.location.coordinates[1]}
            latitude={node.location.coordinates[0]}
            key={node._id}
          >
            <Location size="20" variant='Bold' color={node.isactive ? "red" : "#2242dd"} onClick={() => { setActiveNode(node) }} />
          </Marker>)
        }
        {
          activeNode !== null ? <Popup latitude={activeNode.location.coordinates[0]} longitude={activeNode.location.coordinates[1]}
            closeOnClick={false}
            onClose={() => setActiveNode(null)}>
            <div className='p-1 min-w-[150px] text-slate-800'>
              <h1 className='text-lg font-semibold'>{activeNode.name} {!activeNode.isactive ? '(inactive)' : ''}</h1>
              <h1 className='font-semibold'>{activeNode.location.name}</h1>
              {
                activeNode.history.length ?
                  <div className='grid grid-cols-2 gap-3 mt-3'>
                    <h1 className='text-center text-sm'>temp: <br /> {graphState[graphState.length - 1]?.temp}</h1>
                    <h1 className='text-center text-sm'>hum: <br />  {graphState[graphState.length - 1]?.humidity}</h1>
                    <h1 className='text-center text-sm'>bar_p: <br />  {graphState[graphState.length - 1]?.bar_pressure}</h1>
                    <h1 className='text-center text-sm'>vap_p: <br />  {graphState[graphState.length - 1]?.vapor_pressure}</h1>
                  </div>
                  : <h1 className='opacity-70'>no data</h1>
              }
            </div>
          </Popup> : <></>
        }
      </ReactMapGl>

      <div className='fixed h-20 top-0 left-0 max-w-sm w-full p-5'>
        <header className='h-14 w-full bg-slate-800 text-white rounded-xl flex justify-between items-center px-4 mb-5 shadow-xl'>
          <h1 className='flex items-center'> <Cloud variant='Bold' color='white' size='32' className='mr-1' />Weather Wan</h1>
          <button className='hover:scale-105 transition-all' onClick={() => setShowMain(show => !show)}>
            {
              !showMain ?
                <HambergerMenu size="32" color="white" variant="Bold" /> :
                <CloseSquare size="32" color="white" variant="Bold" />
            }
          </button>
        </header>

        <main className={`text-white h-fit w-full bg-slate-800/90 rounded-xl duration-1000 transition-all relative ${showMain ? 'left-0 opacity-100' : '-left-96 opacity-0'}`}>
          <h1 className='p-5 text-lg font-semibold'>Nodes Data</h1>
          <Scrollbars style={{width : '100%', height : '400px'}}>
            {
              nodeData.length ?
                <div className='grid gap-7 p-5'>
                  {
                    nodeData.map(
                      (node) => (<div className='flex items-center justify-between relative' key={node._id}>
                        {
                          (activeNode?.name === node.name) &&
                          <span className='absolute w-2 h-full bg-white -left-5'></span>
                        }
                        <h1 className='flex items-center'><Location size="30" color="white" variant="Bold" className='mr-2 hover:scale-110 cursor-pointer transition-all'
                          onClick={() => setActiveNode(node)} />{node.name} {!node.isactive ? '(inactive)' : ''} <br />{node.location.name} </h1>
                        <button className='disabled:opacity-50 text-sm bg-white text-slate-800 font-semibold p-2 rounded-lg hover:scale-105 transition-all'
                          disabled={!node.history.length}
                          onClick={() => { setShowGraph(true); setActiveNode(node) }}>Show Graph</button>
                      </div>)
                    )
                  }
                </div> :
                <div className='w-full flex flex-col justify-center items-center h-96'>
                  <ReactLoading type='spin' color='white' className='w-20 h-20' />
                  <h1 className='mt-3'>Fetching Nodes data</h1>
                </div>
            }
          </Scrollbars>
        </main>
      </div>

      <Graphs node={activeNode} graphState={graphState} show={showGraph} toggle={() => setShowGraph(false)} />
    </div>
  );
}

export default App;
